import React from "react";

import EventTeaser from "./EventTeaser";
import EventSkeletons from "./EventSkeletons";

const EventOverviewResults = ({ events, loading }) => {
    if (loading) {
        return (
            <div className="event-overview-results">
                <EventSkeletons />
            </div>
        );
    }

    if (events.length === 0 && !loading) {
        return (
            <div className="event-overview-results">
                <p className="event-overview-results__status">Geen resultaten</p>
            </div>
        )
    };

    return (
        <div className="event-overview-results">
            {events.map(event => (
                <EventTeaser event={event} key={event.id} />
            ))}
        </div>
    )
};

export default EventOverviewResults;
